import { useMemo } from 'react';
import { useImportExportApi } from '../../../clients/quipli-service/import-export/import-export-api';
import { ImportExportAdapter } from '../../../components/import-export/types';
import { DateTime } from 'luxon';
import { toast } from '../../../util/toasts';
import { Typography } from '../../../components/typography/typography';

type ServicesImportParams = Record<string, never>;
type ServicesExportParams = Record<string, never>;

export const useServicesImportExportAdapter = (
  fetchCallback: () => void,
): ImportExportAdapter<ServicesImportParams, ServicesExportParams> => {
  const api = useImportExportApi();

  return useMemo(
    () => ({
      typeLabel: 'services',
      fileAccept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',

      defaultExportFileName: () => `Services_${DateTime.local().toFormat('D').replaceAll('/', '-')}`,

      export: () => api.exportServices(),
      import: (file: File) => api.importServices(file),
      exportSample: () => api.exportServicesSample(),

      onImportSuccess: () => {
        toast('File uploaded successfully. You will received an email when the import is complete.', 'success');
        fetchCallback();
      },
      onImportError: () => {
        toast('Error importing services', 'error');
        fetchCallback();
      },
      onExportSuccess: () => {
        fetchCallback();
      },
      onExportError: () => {
        toast('Error exporting services', 'error');
        fetchCallback();
      },

      renderSampleFile: ({ exportSampleFile }: { exportSampleFile: () => void }) => (
        <div className="text-center px-4 mb-4">
          <Typography type="text-sm" className="text-grey-500">
            <div>Import services from a XLS or XLSX spreadsheet file.</div>
            <div>
              Click{' '}
              <a className="text-quipli-black-800 underline cursor-pointer" onClick={exportSampleFile}>
                here
              </a>{' '}
              to see the exact format of the worksheets.
            </div>
          </Typography>
        </div>
      ),
    }),
    [fetchCallback],
  );
};
